import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.scss'],
})
export class ZoomComponent implements OnInit {
  TiempoVisible = 0
  @Input() Img = ""
  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.Zoom = {
        "transition": "300ms", "width": "100%", "height": "100%",
        "background-image": "url('" + String(this.Img) + "')"
      }
    }, 100);
  }

  id = ""
  Zoom = { "transition": "300ms", "width": "100%", "height": "100%", "background-image": "url('')" }
  TamanoZoom = 2


  
  ZoomInOut() {
    this.id == "dd" ? this.id = "" : this.id = "dd"
    this.Zoom = {
      "transition": "300ms", "width": "100%", "height": "100%",
      "background-image": "url('" + String(this.Img) + "')"
    }
    if (this.id) {
      this.TiempoVisible = 3000
      this.VerificarTiempoVisible()
      this.Zoom = {
        "transition": "300ms", "width": "150%", "height": "150%",
        "background-image": "url('" + String(this.Img) + "')"
      }
      setTimeout(() => {
        this.loadExternalScript("../../../assets/js/dragscroll.js")
      }, 100);
    } else {
      this.TiempoVisible = 0
    }
  }


  VerificarTiempoVisible() {
    if (this.TiempoVisible > 0) {
      this.TiempoVisible -= 100
      setTimeout(() => {
        this.VerificarTiempoVisible()
      }, 100);
    }

  }

  MoreZoom() {

  }

  public loadExternalScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    body.appendChild(script);
  }
}
